<div class="container-fluid mt-2 mb-2">
    <div class="row mt-2">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <div class="row">
        <div class="col">
            <h2>Add Payment Method</h2>
        </div>
    </div>
    <div class="row mt-2">
        <div class="container-fluid">
            <div class="row">
                <h3 class="mat-h3">Billing Information</h3>
            </div>
            <form [formGroup]="billingForm" class="row">
                <div class="col-4">
                    <mat-form-field>
                        <input matInput type="text" id="firstName" name="firstName" placeholder="First Name"
                            formControlName="firstName">
                        <mat-error *ngIf="billingForm.get('firstName').errors?.required">First Name is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('firstName').errors?.validationErrors">
                            {{ billingForm.get("firstName").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field>
                        <input matInput type="text" id="lastName" name="lastName" placeholder="Last Name"
                            formControlName="lastName">
                        <mat-error *ngIf="billingForm.get('lastName').errors?.required">Last Name is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('lastName').errors?.validationErrors">
                            {{ billingForm.get("lastName").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field>
                        <input matInput type="text" id="email" name="email" placeholder="Email"
                            formControlName="email">
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field>
                        <input matInput type="text" id="city" name="city" placeholder="City"
                            formControlName="city">
                        <mat-error *ngIf="billingForm.get('city').errors?.required">City is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('city').errors?.validationErrors">
                            {{ billingForm.get("city").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field>
                        <mat-label>State</mat-label>
                        <mat-select id="state" name="state" formControlName="state">
                            <mat-option *ngFor="let state of states" [value]="state">
                                {{ state }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="billingForm.get('state').errors?.required">State is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('state').errors?.validationErrors">
                            {{ billingForm.get("state").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field>
                        <input matInput type="text" id="country" name="country" placeholder="Country"
                            formControlName="country">
                        <mat-error *ngIf="billingForm.get('country').errors?.required">Country is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('country').errors?.validationErrors">
                            {{ billingForm.get("country").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field>
                        <input matInput type="text" id="postalCode" name="postalCode" placeholder="Zip Code"
                            formControlName="postalCode">
                        <mat-error *ngIf="billingForm.get('postalCode').errors?.required">Zip Code is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('postalCode').errors?.validationErrors">
                            {{ billingForm.get("postalCode").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12">
                    <mat-form-field>
                        <input matInput type="text" id="address1" name="address1" placeholder="Address 1"
                            formControlName="address1">
                        <mat-error *ngIf="billingForm.get('address1').errors?.required">Address 1 is
                            required</mat-error>
                        <mat-error *ngIf="billingForm.get('address1').errors?.validationErrors">
                            {{ billingForm.get("address1").errors?.validationErrors}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12">
                    <mat-form-field>
                        <input matInput type="text" id="address2" name="address2" placeholder="Address 2"
                            formControlName="address2">
                    </mat-form-field>
                </div>
            </form>
        </div>
        <div class="row">
            <h3 class="mat-h3">Credit Card Details</h3>
        </div>
        <div class="row align-items-baseline">
            <div class="col-10">
                <mat-card class="p-3">
                    <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                        <ngx-stripe-card [options]="cardOptions" (change)="onCardChange($event)" />
                    </ngx-stripe-elements>
                </mat-card>
            </div>
            <div class="col-2">
                <section class="align-content-center">
                    <mat-checkbox [(ngModel)]="isDefault" [disabled]="isDefaultDisabled">Default</mat-checkbox>
                </section>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12 d-flex justify-content-start align-items-center gap-3">
            <button mat-raised-button [disabled]="isLoading || !isCardValid" (click)="savePayment()">Save</button>
            <button mat-raised-button class="warning" (click)="cancelSetupIntent()" [disabled]="isLoading" *ngIf="showCloseButton">Cancel</button>
        </div>
    </div>
</div>